import Immutable from 'immutable';

export function keyIn(...keys) {
  // Use with Map.filter(keyIn(<keys>)) -- similar to _.pick()
  const keySet = Immutable.Set(keys);
  return (v, k) => keySet.has(k);
}
